import { render, staticRenderFns } from "./hotgpt.vue?vue&type=template&id=38b4b496&scoped=true"
import script from "./hotgpt.vue?vue&type=script&lang=js"
export * from "./hotgpt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b4b496",
  null
  
)

export default component.exports